<div
        class="flex flex-col items-center justify-center gap-3"
        [class.text-red-500]="leaderboardRow.averageComparison < 0"
        [class.text-green-500]="leaderboardRow.averageComparison > 0"
>
    <span>{{leaderboardRow.averageValueToCompare}}</span>
    <span>{{leaderboardRow.averageComparison  > 0 ? leaderboardRow.averageComparison : leaderboardRow.averageComparison * -1 | number:'1.0-0'}}%</span>
</div>
